/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn } from "@/lib/utils";
import { useImageDocDisplay } from "../hook/use-image-doc-display";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { AlertCircle, LoaderCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export const TextDocViewer = ({ filePath, className }: any) => {
  const { genericState } = useImageDocDisplay(filePath);

  return (
    <div className={cn("overflow-y-auto relative", className)}>
      {genericState.loading ? (
        <div className="absolute left-0 top-0 right-0 bottom-0 flex items-center justify-center w-full h-[500px]">
          <LoaderCircle className="animate-spin" />
        </div>
      ) : null}

      <ConditionRenderer condition={genericState.loading}>
        <></>
        <>
          {genericState?.error ? (
            <div className="p-2">
              <Alert variant="destructive">
                <AlertCircle className="h-4 w-4" />
                <AlertTitle>Error</AlertTitle>
                <AlertDescription>Document load failed</AlertDescription>
              </Alert>
            </div>
          ) : (
            <img src={genericState.url} className="relative" />
          )}
        </>
      </ConditionRenderer>
    </div>
  );
};
